import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpApiService } from '../../../../shared/services/base/http-api.service';
import { ValidationMessageService } from '../../../../shared/services/base/validation-message-handle';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { UnitMeasureModel } from 'src/app/shared/entities/unit-measure.model';
import { UnitMeasureService } from 'src/app/shared/services/app/unit-measure.service';


@Component({
    selector: 'app-unit-measure-add-edit',
    templateUrl: './unit-measure-add-edit.component.html',
    styleUrls: ['./unit-measure-add-edit.component.scss']
})
export class UnitMeasureAddEditComponent implements OnInit {

    public uid: string = null;
    public unitMeasureModel: UnitMeasureModel = new UnitMeasureModel();
    public loading = false;
    public form: UntypedFormGroup;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private formBuilder: UntypedFormBuilder,
        private httpApiService: HttpApiService,
        private validationMessageService: ValidationMessageService,
        private unitMeasureService: UnitMeasureService,
        private messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        this.uid = (this.config.data) ? this.config.data.uid : null;

        this.createForm();

        if (this.uid) {
            this.getItem();
        }

        return;
    }

    onCloseDialog(unit_measure: UnitMeasureModel) {
        this.ref.close(unit_measure);
    }


    createForm(): void {
        this.form = this.formBuilder.group({
            uid: [this.unitMeasureModel.uid],
            name: [this.unitMeasureModel.name, [Validators.required, Validators.maxLength(200)]]
        });
    }

    getItem(): void {
        this.loading = true;
        this.unitMeasureService.get(this.uid)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.unitMeasureModel.map(response.payload);
                this.form.patchValue(this.unitMeasureModel);
            });
    }


    onCancel(): void {
        this.ref.close(null);
    }

    checkIfFormValid(): boolean {
        if (this.form.invalid) {
            this.messageService.add({
                severity: 'error',
                summary: 'Formularul nu este valid!',
                detail: 'Vericficati toate campurile si incercati din nou.'
            });
            this.form.markAllAsTouched();
            return false;
        }
        return true;
    }

    onSave(): void {
        if (!this.checkIfFormValid()) {
            return;
        }
        this.loading = true;
        const data = this.form.getRawValue();
        this.unitMeasureService.set(data)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.unitMeasureModel.map(response.payload);
                this.form.patchValue(this.unitMeasureModel);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Unitatea de masura a fost salvata cu success!'
                });
                this.ref.close(this.unitMeasureModel);
            }, err => {
                if (err instanceof HttpErrorResponse) {
                    this.validationMessageService.serverSideValidation(err, this.form, '', true);
                }
            });
    }

}
